import React from 'react'

export default function Dashboard() {
    let type=JSON.parse(localStorage.getItem('userdet'));
    return (
        <div>
            <div className='textfilledge'>
                <div className='textdashboard'>
                    {/* {type.first_name+' '+type.last_name}<br/>
                    {type.email}<br/> */}
                </div>
                {type.type_of_account}
            </div>
        </div>
    )
}
